export default {
  id: "gaokao-comeback-story",
  pride: 50176,
  slug: "gaokao-comeback-story",
  series: "gaokao",
  category: ["video", "blog"],
  status: "released",
  experienceable: true,
  titleKey: {
    zh: "从二本到全省1200名，我高三一年的逆袭故事",
    en: "From Tier-2 to Top 1200 in the Province — My Senior Year Comeback"
  },
  bilibiliVideoId: "BV1koZjBhE2o",
  descriptionKey: {
    zh: "从450到668，从倒数第二到全省1200名。2020广东理科。方法论、框架论、记忆宫殿，在绝境中把一切变成资源。",
    en: "From 450 to 668, from near-last to top 1200 in the province. Guangdong Science 2020. Methodology, frameworks, memory palace — turning everything into a resource from the brink."
  },
  date: { year: 2026, month: 2, day: 15 },
  genres: ["励志", "高三逆袭"],
  themes: ["方法论", "逆袭", "高考", "人生故事"],
  achievements: [
    { zh: "450 → 668，全省倒数 → 1200名", en: "450 → 668, from near-last to provincial top 1200" }
  ],
  developerNotesKey: {
    zh: "从450到668，从倒数第二到全省1200名。终于有机会讲成一个完整的编年体故事。2020广东理科 | 语数英+理综。方法论中毒、框架论、记忆宫殿、想象中的存在。在绝境中把自己身上所有不像资源的东西都变成资源。比起方法论教程它更像人生故事，请保留你的个人判断。",
    en: "From 450 to 668, from near-last to provincial top 1200. Finally a chance to tell this as a complete chronological story. Guangdong Science 2020. Methodology addiction, frameworks, memory palace, imagined presences. Turning everything that didn't look like a resource into one, from rock bottom. More of a life story than a how-to guide — keep your own judgment."
  },
  tags: ["VRChat", "高考"],
  longDescriptionKey: {
    zh: "",
    en: ""
  },
  links: [
    { type: "bilibili", url: "https://www.bilibili.com/video/BV1koZjBhE2o/", textKey: { zh: "B站观看", en: "Watch on Bilibili" } }
  ]
};
